export default {
  title: 'Consumption',
  footnote:
    'Delivery is counted in decimal gigabytes (1 GB = 1,000,000,000 bytes); playback from inside Videas is neither counted nor billed.',
  periods: {
    label: 'Period',
    week: '7 days',
    month: 'This month',
    previousMonth: 'Last month',
    quarter: '3 months',
  },
  modes: {
    label: 'Show',
    euros: 'In euros',
    volumes: 'In volumes',
  },
  kpi: {
    total: 'Total for the period',
    projection: 'estimated month end ≈ {amount}',
    delivered: 'Delivered over the period',
    delivery: 'Delivery included this month',
    deliveryOf: 'of {included}',
    deliveryNone: 'Nothing delivered this month',
    // A month with no free delivery (`delivery.ts`' `franchiseOf`): never paid, or paid during it.
    deliveryNeverPaid: 'None this month: free delivery comes with the month after your first top-up.',
    deliveryFrom: 'None this month: free delivery starts on {date}.',
    stored: 'Stored today',
    storedRate: '≈ {amount} a day',
  },
  chart: {
    title: 'Day by day',
    hint: 'Hover a bar for the day’s detail.',
    empty: 'Nothing consumed over this period.',
    label: 'Consumption per day',
    meters: {
      bandwidth: 'Delivery',
      video: 'Stored video',
      files: 'Stored files',
    },
  },
  table: {
    service: 'Service',
    volume: 'Volume',
    rate: 'Current price',
    cost: 'Cost',
    total: 'Total',
    included: 'Included',
    services: {
      subscriptions: 'Channel and domain',
      video: 'Video storage',
      files: 'File storage',
      videoFirstMonth: 'First month of video storage',
      filesFirstMonth: 'First month of file storage',
      subtitles: 'Automatic subtitles',
      delivery: 'Delivery',
      other: 'Other',
    },
    subscriptionsVolume: '{count} subscription | {count} subscriptions',
    subscriptionsRate: '{amount} a month each',
    videoBySources: 'By the GB of their sources, on the files’ line',
    storedOn: '{volume} on {date}',
    deliveryRate: '{included} included a month, then {rate}',
    deliveryRateNeverPaid: '{rate} from the first GB; {included} included a month from the month after your first top-up',
    deliveryRateFrom: '{rate} from the first GB this month; {included} included a month from {date}',
  },
  // Keyed on the priced unit the server serves on each usage row (`priced_unit`).
  units: {
    gigabyte: 'GB',
    hour: 'h',
    minute: 'min',
  },
}
